import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CircleCheck, LogOut } from 'lucide-react';

const DeclarationStep = ({ onBack }) => {
  const [declaration, setDeclaration] = useState({
    id: null,
    name: null,
    id_number: null,
  });

  const navigate = useNavigate();

  // Fetch user declaration data
  useEffect(() => {
    const fetchDeclarationData = async () => {
      const apiUrl = "https://portal.lsb.go.ke/account/declaration/";
      const accessToken = localStorage.getItem("accessToken");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || "Failed to fetch declaration data.");
        }

        const data = await response.json();
        if (data.length > 0) {
          const userData = data[0]; // Assuming one user record
          setDeclaration({
            id: userData.user_id || userData.id || null,
            name: userData.name || "John Doe",
            id_number: userData.id_number || "00000000",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    };

    fetchDeclarationData();
  }, []);

  const handleSubmit = async () => {
    const apiUrl = "https://portal.lsb.go.ke/account/declaration/";
    const accessToken = localStorage.getItem("accessToken");

    // Build payload
    const payload = {
      id: declaration.id,
      name: declaration.name,
      id_number: declaration.id_number,
      declaration_data_complete: true,
      step_6: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to submit declaration.");
      }

      Swal.fire({
        title: "Success!",
        text: "Your information has been submitted successfully. Welcome Aboard!",
        icon: "success",
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/finalDashL");
      }, 5000);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "Failed to submit declaration.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    Swal.fire({
      title: 'Success',
      text: 'You have been logged out.',
      icon: 'success',
      width: 370,
    });
    navigate('/portal');
  };

  return (
    <div className="px-4 lg:px-8 py-8 container mx-auto flex flex-col items-center">
      <div className="p-8">
        <div className="flex flex-col items-center mb-6">
          <CircleCheck className="w-[50px] h-[50px] mb-2 rounded-full bg-[#3d0707] text-[#ebcab3]" />

          <h3 className="font-bold mb-2 text-[#3d0707] tracking-wide underline underline-offset-4 decoration-[#ebcab3]">
            Declaration
          </h3>
        </div>

        <div className="border border-[#ebcab3] rounded-lg p-6 mb-4 shadow-inner">
          <p className="text-gray-700 leading-8">I,{" "} <b className="underline underline-offset-4 decoration-2 decoration-[#ebcab3] uppercase font-semibold text-[#3d0707]">{declaration.name || "John Doe"}</b>, of ID Number{" "} <b className="underline underline-offset-4 decoration-2 decoration-[#ebcab3] font-semibold text-[#3d0707]">{declaration.id_number || "00000000"}</b>, solemnly and sincerely declare that all the information I provided is accurate and factual to the best of my knowledge.
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="pt-8 flex gap-3 justify-center">
          <button type="button" onClick={onBack} className="button">
            <span className="button_lg">
              <span className="button_sl"></span>
              Back
            </span>
          </button>
          <button type="button" onClick={handleSubmit} className="button">
            <span className="button_lg">
              <span className="button_sl"></span>
              Submit
            </span>
          </button>
        </div>

        {/* logout function */}
        <div className="flex justify-center mb-6">
          <button
            onClick={handleLogout}
            className="py-2 px-3 bg-red-600 hover:font-bold uppercase text-white flex gap-2 items-center rounded-md text-sm transition-transform duration-200 ease-in-out hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-red-400 shadow-sm hover:shadow-lg"
          >
            <span className="transition duration-200 ease-in-out group-hover:pr-1">Logout</span>
            <LogOut className="w-5 h-5 transition-transform duration-200 group-hover:rotate-[-15deg]" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclarationStep;